export const ASSET_TYPES = {
    OBSERVATION: 'observation'
};
